<div class="card-base">
  <div class="card-content-made-cash-desk-search">
    <div class="chip-container">
      <mat-chip-list>
        <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
          {{ filt.valueView }}
          <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="card-container mat-elevation-z1">
      <div class="clearfix">
        <div class="pull-left div-header-left">
          <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
          <made-cash-desk-filter #filters></made-cash-desk-filter>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div class="card-content margin-botton-medium">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <p-scrollPanel *ngIf="!loading" styleClass="scroll-panel">
          <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="MedicalAppointmentDate">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Fecha" #resColMedicalAppointmentDate></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div><b>{{element.MedicalAppointmentDate}}</b></div>
              </td>
            </ng-container>
            <ng-container matColumnDef="InvoiceNumber">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Número" #resColNumber></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div><b>{{element.InvoiceNumber}}</b></div>
              </td>
            </ng-container>
            <ng-container matColumnDef="InvoiceAmount">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Importe" #resColInvoiceAmount></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.InvoiceAmount}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="Protocol">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Protocolo" #resColProtocol></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.Protocol}}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="PatientFullName">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Paciente" #resColPatient></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.PatientFullName}}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="Practice">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Práctica" #resColPractice></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.Practice}}</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="InvoiceTypeDescription">
              <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="50" tile="Tipo" #resColInvoiceTypeDescription></resizable-column-control>
              </th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.InvoiceTypeDescription}}</div>
              </td>
            </ng-container>
            <!-- Star Column -->
            <ng-container matColumnDef="Star" stickyEnd>
              <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
              <td class="search-table-cell" mat-cell *matCellDef="let element">
                <button mat-icon-button [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuItem="matMenu">
                  <button *ngIf="canGenerate(element)" (click)="invoicePatientCashDeskRedirect(element)" mat-menu-item>
                    <mat-icon>edit</mat-icon><span>Generar nota de crédito</span>
                  </button>
                  <button (click)="invoicePatientCashDeskViewRedirect(element)" mat-menu-item>
                    <mat-icon>edit</mat-icon><span>Ver</span>
                  </button>
                  <button   (click)="sendMail(element)" mat-menu-item>
                    <mat-icon>mail</mat-icon><span>Enviar por mail</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </p-scrollPanel>
        <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
      </div>
    </div>
  </div>
</div>
